import React from 'react';
import {List} from '@material-ui/core';
import {NavLink} from 'react-router-dom';

import IntlMessages from "../../../util/IntlMessages";
import {Link} from "@mui/material";
import BBIconExternalLink from "../../../assets/bbCustomIcons/BBIconExternalLink";
import Tooltip from "@material-ui/core/Tooltip";

const NavMenuItem = props => {
  const {name, icon, link, className="", isExternalLink = false} = props;

  const nameIsString = typeof name === "string";

  return (
    <List component="div" className='nav-menu-item'>
        {isExternalLink
        ? <Link target="_blank" rel="noopener" className={`prepend-icon nav-menu-link ${className}`} href={link ? link : ""}>
                {(!!icon && typeof icon === "string") && (
                    <i className={'zmdi zmdi-hc-fw  zmdi-' + icon}/>
                )}
                {(!!icon && typeof icon !== "string") && (
                    //assume since it's not a string, that it is a component
                    icon
                )}
                {nameIsString && (
                    <span className="nav-text"><IntlMessages id={name}/></span>
                )}
                {!nameIsString && (
                    <span className="nav-text">{name}</span>
                )}
                <Tooltip title={`External Link to ${link}`} className={'ml-1'}>
                    <span>
                        <BBIconExternalLink style={{fontSize: "smaller", margin:"3px", marginTop: 1}}/>
                    </span>
                </Tooltip>

            </Link>
        : <NavLink className={`prepend-icon nav-menu-link ${className}`} to={link ? link : ""} >
                {(!!icon && typeof icon === "string") && (
                    <i className={'zmdi zmdi-hc-fw  zmdi-' + icon}/>
                )}
                {(!!icon && typeof icon !== "string") && (
                    //assume since it's not a string, that it is a component
                    icon
                )}
                {nameIsString && (
                    <span className="nav-text" id={className}><IntlMessages id={name}/></span>
                )}
                {!nameIsString && (
                    <span className="nav-text" id={className}>{name}</span>
                )}

            </NavLink>
        }

    </List>
  )
};

export default NavMenuItem;